"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_components_text_info_n_1 = __importDefault(require("@gerenciatd/next.components.text-info-n"));
const Breadcrumb = (props) => {
    const { breadcrumb } = props;
    if (!breadcrumb) {
        return null;
    }
    const items = Object.entries(breadcrumb.breadCrumbs);
    let i = 0;
    return (react_1.default.createElement("nav", { className: "container" },
        react_1.default.createElement("ul", { className: "breadcrumb", "data-cy": "Header breadcrumb" },
            items.map(([key, value]) => {
                const link = value || '#';
                const text = key;
                return (react_1.default.createElement("li", { key: `item-${i++}`, className: "breadcrumb-item" },
                    react_1.default.createElement(next_components_custom_link_1.default, { href: link, title: "", ariaLabel: "", taggingInfo: {
                            componentName: 'header',
                            componentContent: text,
                            componentVariation: 'breadcrumb',
                            componentPerso: '',
                            componentProduct: '',
                        } },
                        react_1.default.createElement(next_components_text_info_n_1.default, { text: text, fontType: "font-regular", size: "caption03", color: "grey6", display: "inline" }))));
            }),
            react_1.default.createElement("li", { className: "breadcrumb-item active" },
                react_1.default.createElement(next_components_text_info_n_1.default, { text: breadcrumb.title, fontType: "font-regular", size: "caption03", color: "grey5", display: "inline" })))));
};
exports.default = Breadcrumb;
//# sourceMappingURL=index.js.map